import { AppEnvironment } from 'app/app-config/app-config.model';

/**
 * Used to configure the MediaAlpha API key for each environment.
 * You can find the implementation of API keys here: https://insurance-exchange.mediaalpha.com/help/code.html?;deyupIRyzMfWqQxckt36WEliBVJELCNANpqrtq0lPX6858DdqZ64Kl0PLOlYSAJFayy1pRMyfS-l8RFxP8Dh3o2sAQaq2g#ads-server-side-feed-integration.
 * Access the dashboard and any other information here: https://insurance-exchange.mediaalpha.com/#dashboard
 * Note that the API key and Placement Key are likely the same across all environments.
 *
 * Requests go through dot-com's MediaAlpha proxy (see LG-2677) because MediaAlpha's
 * API returns no CORS headers. The endpoint URL is derived from apiRoot.quoteV1 in
 * MediaAlphaService; which MediaAlpha host the proxy forwards to (test vs prod) is
 * controlled by dot-com's MEDIAALPHA_RESULTS_HOST env var per environment.
 */
export const mediaAlphaAPIToken: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['development', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['staging', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
  ['production', 'cT0FvSO3bI5LqneJojWLOsC5xh1Up923'],
]);

export const mediaAlphaPlacementKeyUWF: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['development', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['staging', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
  ['production', 'x586s2FQ2osV7nP8tngxGJE3achDkw'],
]);

export const mediaAlphaPlacementKeyOOM: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['development', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['staging', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
  ['production', 'GgLTFe-f3uItsGeHAerE2-OFT3qw8w'],
]);
